// extracted by mini-css-extract-plugin
export default {"loadingContainer":"styles_loadingContainer__x2M8P","ldsFacebook":"styles_ldsFacebook__x-XZu"};